import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { GoogleMap, MarkerF, OverlayView } from "@react-google-maps/api";
import COLORS from "../../../constants/Colors";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const WheelzMap = ({
  height = "400px",
  lat = null,
  lng = null,
  invalidCoordMsg,
  xOffset = null,
  yOffset = null,
  zoom = 10,
  label = null,
}) => {
  const [validCoords, setvalidCoords] = useState(false);

  useEffect(() => {
    if (lat && lng) {
      setvalidCoords(true);
    } else {
      setvalidCoords(false);
    }
  }, [lat, lng]);

  const calculateNewLongitude = (lng, offsetPx, zoom) => {
    const scale = Math.pow(2, zoom);
    const degreesPerPixel = 360 / (256 * scale);
    return lng - offsetPx * degreesPerPixel;
  };

  const calculateNewLatitude = (lat, offsetPx, zoom) => {
    const scale = Math.pow(2, zoom);
    const degreesPerPixel = 360 / (256 * scale);
    return lat + offsetPx * degreesPerPixel;
  };

  const defaultProps = {
    center: {
      lat: yOffset
        ? calculateNewLatitude(parseFloat(lat), yOffset, zoom)
        : parseFloat(lat),
      lng: xOffset
        ? calculateNewLongitude(parseFloat(lng), xOffset, zoom)
        : parseFloat(lng),
    },
    markerCenter: {
      lat: parseFloat(lat),
      lng: parseFloat(lng),
    },
    zoom: zoom,
  };

  const InvalidCoordsError = () => {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
        }}
      >
        <Typography
          fontSize={14}
          sx={{
            opacity: "0.6",
          }}
        >
          Oops!
        </Typography>
        <Typography
          fontSize={14}
          sx={{
            opacity: "0.6",
          }}
        >
          {invalidCoordMsg || "Invalid location coordinates."}
        </Typography>
      </Box>
    );
  };

  return (
    <>
      {!validCoords && <InvalidCoordsError />}
      {validCoords && (
        <Box
          sx={{
            height: height,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {" "}
          <GoogleMap
            mapContainerStyle={{
              height: "100%",
              width: "100%",
            }}
            center={defaultProps.center}
            zoom={defaultProps.zoom}
            options={{
              mapTypeControl: false,
              streetViewControl: false,
            }}
          >
            <OverlayView
              position={defaultProps.markerCenter}
              mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  textWrap: "nowrap",
                  alignItems: "center", 
                }}
              >
                <MarkerF position={defaultProps.markerCenter} />
                {label && <Typography
                  fontSize={"0.8rem"}
                  fontWeight={500}
                  color={COLORS.PRIMARY}
                  sx={{
                    mt: "-60px",
                    cursor:"pointer",
                    background:"white",
                    padding:"0px 5px",
                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)", 
                    display:"flex",
                    flexDirection:"center",
                    alignItems:"center",
                    justifyContent:"center"
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    if (lat && lng) {
                      const mapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;
                      window.open(mapsUrl, "_blank");
                    }
                  }}
                >
                  
                  {label}
                  <OpenInNewIcon sx={{
                    fontSize:"16px",
                    ml:"5px"
                  }}/>
                </Typography>}
              </Box>
            </OverlayView>
          </GoogleMap>
        </Box>
      )}
    </>
  );
};

WheelzMap.propTypes = {
  lat: PropTypes.number.isRequired,
  lng: PropTypes.number.isRequired,
  invalidCoordMsg: PropTypes.string,
  height: PropTypes.string,
  zoom: PropTypes.string,
  xOffset: PropTypes.string,
  yOffset: PropTypes.string,
  label: PropTypes.string,
};

export default WheelzMap;
